<template>
  <div>
    <!-- 对账明细开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单对账明细"
      :visible.sync="billVisible"
      :before-close="billHandleClose"
      width="67.8%"
      center
    >
      <el-divider></el-divider>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColorLeft"
          :cell-style="cellStyleLeft"
          key="onee"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="180"></el-table-column>
          <el-table-column prop="name" label="单量"></el-table-column>
          <el-table-column prop="name" label="账单号"></el-table-column>
          <el-table-column prop="address" label="业务周期"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="结算金额(元)"></el-table-column>
        </el-table>
      </div>
      <div class="btn">
        <el-button @click="diffCheckFn()">差异核对</el-button>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          key="two"
          :header-cell-style="tableHeaderColorLeft"
          :cell-style="cellStyleLeft"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index">
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column prop="name" label="业余时间"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="结算金额"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" style="color: #E74C3C;">差异处理</el-button>
              <el-button type="text">订单确认</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 对账明细结束 -->
    <!-- 订单对账差异核对开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单对账差异核对"
      :visible.sync="diffCheckVisible"
      :before-close="diffHandleClose"
      width="67.8%"
      center
    >
      <el-divider></el-divider>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColorLeft"
          :cell-style="cellStyleLeft"
          key="three"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="180"></el-table-column>
          <el-table-column prop="name" label="单量"></el-table-column>
          <el-table-column prop="name" label="账单号"></el-table-column>
          <el-table-column prop="address" label="业务周期"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="结算金额(元)"></el-table-column>
        </el-table>
      </div>
      <div class="btn">
        <el-button>确认结算</el-button>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColorLeft"
          :cell-style="cellStyleLeft"
          key="four"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index">
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column prop="name" label="业余时间"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="结算金额"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" style="color: #E74C3C;" @click="diffHandle(scope.row)">差异处理</el-button>
              <el-button type="text">订单确认</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 订单对账差异核对结束 -->
    <!-- 差异处理开始 -->
    <el-dialog :close-on-click-modal="false"
      title="差异处理"
      :visible.sync="diffHandleVisible"
      :before-close="diffhandleClose"
      width="52.1%"
      center
    >
      <el-divider></el-divider>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColorLeft"
          :cell-style="cellStyleLeft"
          key="five"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="180"></el-table-column>
          <el-table-column prop="name" label="账单号"></el-table-column>
          <el-table-column prop="address" label="业务周期"></el-table-column>
          <el-table-column prop="address" label="订单号"></el-table-column>
          <el-table-column prop="address" label="结算金额(元)"></el-table-column>
        </el-table>
      </div>
      <div class="diffForm">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="备注:">
            <el-input type="textarea" :autosize="{minRows:3,maxRows:5}" v-model="form.name"></el-input>
            <span>
              <span>注:</span>
              <span>请与分销商确认订单差异,在进行处理决定,否则容易再次驳回</span>
            </span>
          </el-form-item>
          <el-form-item class="itemBtn">
            <el-button>移除此订单</el-button>
            <el-button class="btnL">确认无误</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 差异处理结束 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      billVisible: false, // 对账明细
      diffCheckVisible: false, // 差异核对
      diffHandleVisible: false, // 差异处理
      multipleSelection: [], // 全选
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      form: {
        name: ""
      }
    };
  },
  methods: {
    // 差异处理
    diffHandle() {
      this.diffHandleVisible = true;
    },
    // 差异处理X
    diffhandleClose() {
      this.diffHandleVisible = false;
    },
    // 差异核对
    diffCheckFn() {
      this.diffCheckVisible = true;
    },
    // 差异核对X
    diffHandleClose() {
      this.diffCheckVisible = false;
    },
    // 对账明细
    billDetail() {
      this.billVisible = true;
    },
    // 对账明细X
    billHandleClose() {
      this.billVisible = false;
    },
    // 全选
    // toggleSelection(rows) {
    //   if (rows) {
    //     rows.forEach(row => {
    //       this.$refs.multipleTable.toggleRowSelection(row);
    //     });
    //   } else {
    //     this.$refs.multipleTable.clearSelection();
    //   }
    // },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColorLeft({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColorLeft({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyleLeft({ row, rowIndex }) {
      return this.utils.cellStyleLeft({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.diffForm {
  margin-top: 20px;
  span {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #e74c3c;
    > span:nth-child(1) {
      margin-right: 10px;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-left: -80px;
    .el-button {
      margin-top: 20px;
      width: 100px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #e74c3c;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #e74c3c;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: white;
    }
  }
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
.btn {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
  .el-button {
    width: 120px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>